<template>
  <v-card class="tn-panel">
    <div class="tn-panel__head"><v-icon size="20">mdi-pound</v-icon> References</div>
    <div class="tn-panel__body">
      <dl class="tn-facts tn-facts--stack">
        <div v-for="item in items" :key="item.label">
          <dt>{{ item.label }}</dt>
          <dd><copy-value :value="item.value" :label="item.label" /></dd>
        </div>
      </dl>
    </div>
  </v-card>
</template>

<script>
import CopyValue from './CopyValue.vue'

export default {
  name: 'ReferencesPanel',
  components: { CopyValue },
  props: {
    // [{ label, value }]
    items: { type: Array, default: () => [] }
  }
}
</script>
